import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

// ITL-2807: shared phone helpers for analyst-entered OLV contacts. Centralised
// here so the per-field inline error (ContactReviewSection), the panel-level
// submit guard (OfferLetterVerificationPanel), and the load-time seeding
// (useOfferLetterChecklist) all agree on what "valid" means.

// Validity mirrors the API exactly: `Verification` accepts any E.164 string via
// `~r/^\+[1-9]\d{1,14}$/` — locale-agnostic. We deliberately do NOT gate on
// libphonenumber's `isValidPhoneNumber(value, 'US')`, which rejects valid
// non-US E.164 the API would accept (e.g. +447911123456). Normalization still
// uses the 'US' default below, since analysts most often type US numbers in
// national format.
export const E164_REGEX = /^\+[1-9]\d{1,14}$/;

export function isE164Phone(phone: string | null | undefined): boolean {
  return E164_REGEX.test((phone ?? '').trim());
}

// Returns the value to store: null for blank, E.164 for a number libphonenumber
// can parse (US default for national-format input), or the trimmed input
// unchanged when it can't be parsed (so the inline error stays visible and the
// submit guard keeps it blocked).
export function normalizePhoneToE164(raw: string | null | undefined): string | null {
  const trimmed = (raw ?? '').trim();
  if (trimmed === '') return null;
  if (isValidPhoneNumber(trimmed, 'US')) return parsePhoneNumber(trimmed, 'US').number;
  return trimmed;
}
